import { styled } from '@mui/material/styles';

interface StyledVoiceAudioWavesProps {
  isPlaying: boolean;
}

const StyledVoiceAudioWaves = styled('div')<StyledVoiceAudioWavesProps>(
  ({ isPlaying }) => `
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  height: 100px;
  position: absolute;
  bottom: 3rem;
  left: 1rem;

  @keyframes bounceHeight {
    0% {
      height: 16px;
    }
    50% {
      height: 50px;
    }
    100% {
      height: 16px;
    }
  }

  & div.bar {
    width: 16px;
    border: 2px solid var(--primary-color);
    background-color: white;
    border-radius: 16px;
    animation: bounceHeight 1.5s infinite;
    animation-play-state: ${isPlaying ? 'running' : 'paused'};
  }

  & div.bar:nth-child(1) {
    height: 40px;
    animation-delay: 0.1s;
  }

  & div.bar:nth-child(2) {
    height: 30px;
    animation-delay: 0.3s;
  }

  & div.bar:nth-child(3) {
    height: 50px;
    animation-delay: 0.5s;
  }

  & div.bar:nth-child(4) {
    height: 20px;
    animation-delay: 0.1s;
  }

  & div.bar:nth-child(5) {
    height: 30px;
    animation-delay: 0.3s;
  }
`
);

export default StyledVoiceAudioWaves;
